// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","containNavBar":"Home_containNavBar__fjU9E","containerAbsolute":"Home_containerAbsolute__8MdJq","spinnerMobile":"Home_spinnerMobile__QmhCU"};